// Mega-menu product cards are desktop-only (phones never show them), but ~145 of them were built
// into every page's DOM on every device. sections/navigation.liquid now ships them inside
// <template class="mm-lazy">, which the browser parses as inert: no elements, no images, no work.
//
// This builds them the first time a pointer or keyboard focus reaches a mega-menu item, or once the
// browser is idle on a desktop-width screen, so the first hover is usually already populated. Then
// it re-applies trade (B2B) prices, which b2b-pricing.js only paints onto cards present at init.
(function () {
  if (window.__mmLazyBound) return;
  window.__mmLazyBound = true;

  // Pages now ship the templates EMPTY (data-mm-remote); the filled ones come from the navigation
  // section rendered for the mm-cards view (templates/index.mm-cards.liquid sets template.suffix).
  // Same session/cookies, so the customer context matches the page. Matched by data-mm-key.
  var CARDS_URL = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
    '?view=mm-cards&section_id=navigation';

  var done = false;
  var inFlight = false;

  function applyB2B() {
    var b2b = window.B2BListingPrices;
    if (b2b && b2b.ready) b2b.apply();
    else document.addEventListener('b2b:listing-prices', function () { window.B2BListingPrices.apply(); }, { once: true });
  }

  // The cards response is private/max-age=0, so without this every desktop page view re-fetched
  // ~22 KB. Cache it for the session: 30 min, keyed by theme + logged-in customer (trade prices are
  // re-applied client-side by B2BListingPrices either way).
  var CACHE_TTL = 30 * 60 * 1000;
  function cacheKey() {
    var theme = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '';
    var cid = (window.__st && window.__st.cid) || 'guest';
    return 'hds-mm-cards:' + theme + ':' + cid;
  }
  function readCache() {
    try {
      var v = JSON.parse(sessionStorage.getItem(cacheKey()) || 'null');
      return v && Date.now() - v.t < CACHE_TTL ? v.html : null;
    } catch (e) { return null; }
  }
  function writeCache(html) {
    try { sessionStorage.setItem(cacheKey(), JSON.stringify({ t: Date.now(), html: html })); } catch (e) { /* quota/private mode */ }
  }

  // Card thumbnails arrive with data-mm-srcset only (snippets/product-card-grid-columns.liquid,
  // mm: true), so a warmed-but-unopened menu downloads nothing. The first pointer/focus on a
  // top-level item gives that item's images a real srcset; loading="lazy" keeps the display:none
  // sub-panels deferred until their tab is shown.
  function promote(li) {
    if (!li) return;
    var imgs = li.querySelectorAll('img[data-mm-srcset]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('srcset', imgs[i].getAttribute('data-mm-srcset'));
      imgs[i].removeAttribute('data-mm-srcset');
    }
  }
  function promoteOpen() {
    var open = document.querySelectorAll('li.lvl1.megamenu:hover, li.lvl1.megamenu:focus-within');
    for (var i = 0; i < open.length; i++) promote(open[i]);
  }

  function fill(t, content) {
    t.parentNode.replaceChild(document.importNode(content, true), t);
  }

  function hydrate() {
    if (done || inFlight) return;
    var ts = Array.prototype.slice.call(document.querySelectorAll('template.mm-lazy'));
    var remote = ts.filter(function (t) { return t.hasAttribute('data-mm-remote'); });

    // Inline templates (theme editor, or an older cached page): fill straight away.
    ts.forEach(function (t) { if (!t.hasAttribute('data-mm-remote')) fill(t, t.content); });
    if (!remote.length) { done = true; promoteOpen(); applyB2B(); return; }

    inFlight = true;
    var cached = readCache();
    (cached ? Promise.resolve(cached) : fetch(CARDS_URL, { credentials: 'same-origin', priority: 'low' })
      .then(function (r) { if (!r.ok) throw new Error('mm-cards ' + r.status); return r.text(); })
      .then(function (html) { writeCache(html); return html; }))
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        remote.forEach(function (t) {
          var key = t.getAttribute('data-mm-key');
          var src = key && doc.querySelector('template.mm-lazy[data-mm-key="' + key + '"]:not([data-mm-remote])');
          if (src && t.parentNode) fill(t, src.content);
        });
        done = true;
        promoteOpen();
        applyB2B();
      })
      .catch(function () { /* menu links still work; the next hover retries */ })
      .then(function () { inFlight = false; });
  }

  function fromMenu(e) {
    return e.target && e.target.closest && e.target.closest('li.lvl1.megamenu');
  }
  function onMenu(e) {
    var li = fromMenu(e);
    if (!li) return;
    hydrate();
    promote(li);
  }
  document.addEventListener('pointerover', onMenu, { passive: true });
  document.addEventListener('focusin', onMenu);

  // Desktop only: warm the cards while idle so the first hover is instant. Phones (the menu's
  // product cards are hidden there) never pay for them.
  if (window.matchMedia && window.matchMedia('(min-width: 1025px)').matches) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2000); };
    var warm = function () { idle(hydrate, { timeout: 4000 }); };
    // `load` can stall indefinitely behind a third-party request (seen on live: loadEventEnd still 0
    // after 60 s), so also warm 5 s in. hydrate() ignores repeat calls.
    if (document.readyState === 'complete') warm();
    else { window.addEventListener('load', warm, { once: true }); setTimeout(warm, 5000); }
  }
})();
